/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{create as o}from"../../../../../core/libs/gl-matrix-2/factories/vec4f64.js";import{ColorMixModeEnum as t}from"../../../layers/support/symbolColorUtils.js";class s{constructor(){this.externalColor=o(),this.externalColorMixMode=t.Multiply,this.castShadows=!0,this.pickable=!0,this.elevationOffset=0}}export{s as UniformComponentParameters};
